import request from './index'

export const versionList = listQuery => {
  return request({
    url: '/apk/list',
    method: 'post',
    data: {
      command_id: 82,
      pageIndex: listQuery.pageIndex,
      pageSize: listQuery.pageSize,
	  params: listQuery.params,
	  fuzzySearch: listQuery.fuzzySearch,
	  verTime:listQuery.time?listQuery.time:undefined,
    }
  })
}


